import { render, staticRenderFns } from "./AddOrEdit.vue?vue&type=template&id=90c667a2&scoped=true&"
import script from "./AddOrEdit.vue?vue&type=script&lang=js&"
export * from "./AddOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEdit.vue?vue&type=style&index=0&id=90c667a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c667a2",
  null
  
)

export default component.exports